import { PaletteOptions } from "@mui/material";
import { paletteProviderSearchCore } from "./shared";

// PRIMARY
export const PROVIDER_SEARCH_PRIMARY_DARK = "#AB1A9A";
export const PROVIDER_SEARCH_PRIMARY_MAIN = "#C920B5";
export const PROVIDER_SEARCH_PRIMARY_LIGHT = "#BEA3C6";

export const paletteProviderSearchBavaria: PaletteOptions = {
  ...paletteProviderSearchCore,
  primary: {
    dark: PROVIDER_SEARCH_PRIMARY_DARK,
    light: PROVIDER_SEARCH_PRIMARY_LIGHT,
    main: PROVIDER_SEARCH_PRIMARY_MAIN,
  },
} as const;
